import { Component, Emit, Vue } from 'vue-property-decorator';
import EmptyGraphMessage from '../../assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue'
import moment from "moment";
import store from '@/assets/common/store/store';

@Component({
  components: {
    EmptyGraphMessage
  }
})

export default class ChemcialImportErrorList extends Vue {


  get isNotificationAdmin() {
    return this.$store.getters.isNotificationAdmin
  }

  private chemImpAppTab = false
  private chemImpBaseTab = false
  baseUrl = "/chemical_import_error"
  chemBaseUrl = "basic_imp_error"
  chemAppUrl = "app_imp_error"
  chemicalBaseName = null
  chemicalBaseId = null
  chemicalAppName = null
  chemicalAppValue : string | null = null;
 chemicalBaseValue: string | null = null;
  chemicalAppId = null
  private baseStartDate: string | Date = new Date()
  private baseEndDate: string | Date = new Date()
  private appStartDate: string | Date = new Date()
  private appEndDate: string | Date = new Date()
  private selectedBaseStartDate: string | Date = new Date()
  private selectedBaseEndDate: string | Date = new Date()
  private selectedAppStartDate: string | Date = new Date()
  private selectedAppEndDate: string | Date = new Date()
  chemicalImportBasicErrorList = []
  chemicalImportAppErrorList = [] as any[];
  displayedChemicalImportAppErrorList = [] as any[];
  isBaseButtonDisabled = false;
  isAppButtonDisabled = false
  includeBaseResponse = false
  includeAppResponse = false
  isChemBaseSpinnerLoading = false
  isChemAppSpinnerLoading = false
  chemBaseSortOrder = true;
  chemAppSortOrder = true;
  chemicalBaseImportCount = null;
  chemicalAppImportCount = null;
  private colsNameInital = [] as any[];
  selectedBaseItemName = null;
  selectedAppItemName = null;
  currentAppIndex = 0;

  created() {
    this.chemImpBaseTab = true;
    this.chemImpAppTab = false;
    const currentDate = new Date();
    this.baseStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
    this.baseEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    this.appStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
    this.appEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    this.selectedBaseStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
    this.selectedBaseEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    this.selectedAppStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
    this.selectedAppEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
    this.baseStartDate = this.selectedBaseStartDate;
    this.baseEndDate = this.selectedBaseEndDate;
    this.appStartDate = this.selectedAppStartDate;
    this.appEndDate = this.selectedAppEndDate;
    this.getChemicalBaseImprotError();
    this.getItemsNameByInitial();
  }

  mounted() {
    this.initScrollButton();
  }

  private showAlertOnlyOnMobile(screen: string): void {
    let errorCount = 0;
    if(screen == 'base'){
      errorCount = this.chemicalBaseImportCount ?? this.chemicalImportBasicErrorList.length;
    }
    if(screen == 'app'){
      errorCount = this.chemicalAppImportCount ?? this.chemicalImportAppErrorList.length;
    }
    if (errorCount <= 200) {
        return; 
    }
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobileOrTabletUA = /android|iphone|ipad|ipod/i.test(userAgent); 
    const smallerScreenDimension = Math.min(window.screen.width, window.screen.height);
    const isSmallOrTabletScreen = smallerScreenDimension < 1025; 
    const multiTouch = navigator.maxTouchPoints > 1; 
    if (isMobileOrTabletUA && multiTouch && isSmallOrTabletScreen) {
        alert('スマートデバイスでは、最大200件までの表示になります。');
    }
}

initScrollButton() {
  this.cleanupScrollListeners();

  const scrollDownBtn = document.getElementById("pagebottombtn");
  const scrollUpBtn = document.getElementById("pageupbtn");
  const myDiv = document.getElementById("kembasedidforscroll") as HTMLDivElement | null;

  if (!myDiv) return;

  this.handleScroll = () => {
    const scrollTop = myDiv.scrollTop;
    const windowHeight = myDiv.clientHeight;
    const docHeight = myDiv.scrollHeight;

    if (scrollDownBtn) {
      if (scrollTop + windowHeight < docHeight - 200 && scrollTop > 100) {
        scrollDownBtn.classList.add("show");
      } else {
        scrollDownBtn.classList.remove("show");
      }
    }

    if (scrollUpBtn) {
      const atBottom = scrollTop + windowHeight >= docHeight - 50; 
      const scrolledEnoughFromTop = scrollTop > 200; 
      if (!atBottom && scrolledEnoughFromTop) {
          scrollUpBtn.classList.add("show");
      } else {
          scrollUpBtn.classList.remove("show");
      }
    }
  };

  this.handleScrollDownClick = () => {
    myDiv.scrollTo({
      top: myDiv.scrollHeight,
      behavior: "smooth",
    });
  };

  this.handleScrollUpClick = () => {
    myDiv.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  myDiv.addEventListener("scroll", this.handleScroll);

  if (scrollDownBtn)
    scrollDownBtn.addEventListener("click", this.handleScrollDownClick);
  if (scrollUpBtn)
    scrollUpBtn.addEventListener("click", this.handleScrollUpClick);
}

cleanupScrollListeners() {
  const scrollDownBtn = document.getElementById("pagebottombtn");
  const scrollUpBtn = document.getElementById("pageupbtn");
  const myDiv = document.getElementById("kembasedidforscroll") as HTMLDivElement | null;

  if (scrollDownBtn) scrollDownBtn.classList.remove("show");
  if (scrollUpBtn) scrollUpBtn.classList.remove("show");

  if (this.handleScroll && myDiv)
    myDiv.removeEventListener("scroll", this.handleScroll);

  if (this.handleScrollDownClick && scrollDownBtn)
    scrollDownBtn.removeEventListener("click", this.handleScrollDownClick);

  if (this.handleScrollUpClick && scrollUpBtn)
    scrollUpBtn.removeEventListener("click", this.handleScrollUpClick);
}

private handleScroll?: () => void;
private handleScrollDownClick?: () => void;
private handleScrollUpClick?: () => void;

beforeDestroy() {
  this.cleanupScrollListeners();
}

  async handleSearch(screen: string) {
    if (screen === "base") {
      await this.getChemicalBaseImprotError()
    } else if (screen === "app") {
      await this.getChemicalAppImprotError()
    }
  }

  private async getChemicalBaseImprotError() {
    this.isChemBaseSpinnerLoading = true
    this.chemicalBaseImportCount  = null
    this.chemicalImportBasicErrorList = [];
    if (!this.validateDates('base')) {
      this.isChemBaseSpinnerLoading = false
      this.chemicalImportBasicErrorList = [];
      return
    }
    const baseValue = encodeURIComponent(this.chemicalBaseValue || 'null');
    await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.chemBaseUrl}?chemical_id=${this.chemicalBaseId || 'null'}&chemical_name=${this.chemicalBaseName || 'null'}&start_date=${this.selectedBaseStartDate}&end_date=${this.selectedBaseEndDate}&is_response=${this.includeBaseResponse}&is_item_name=${this.selectedBaseItemName}&is_base_value=${baseValue}`).then(res => {
      
      this.chemicalImportBasicErrorList = res.chemicalBasicError
      this.chemicalBaseImportCount = res.chemicalBasicError.length;
      this.isChemBaseSpinnerLoading = false
      this.showAlertOnlyOnMobile('base')
    }).catch(error => {
      this.$toasted.error('データの取得に失敗しました。')
      this.chemicalImportBasicErrorList = [];
      this.isChemBaseSpinnerLoading = false
    })
  }

  private async getChemicalAppImprotError() {
    this.isChemAppSpinnerLoading = true
    this.chemicalImportAppErrorList = [];
    this.displayedChemicalImportAppErrorList = []; 
    this.chemicalAppImportCount = null;
    if (!this.validateDates('app')) {
      this.isChemAppSpinnerLoading = false
      this.chemicalImportAppErrorList = [];
      this.displayedChemicalImportAppErrorList = [];
      return;
    }
    const appValue = encodeURIComponent(this.chemicalAppValue || 'null');
    await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.chemAppUrl}?chemical_id=${this.chemicalAppId || 'null'}&chemical_name=${this.chemicalAppName || 'null'}&start_date=${this.selectedAppStartDate}&end_date=${this.selectedAppEndDate}&is_response=${this.includeAppResponse}&is_item_name=${this.selectedAppItemName}&is_base_value=${appValue}`).then(res => {
      this.chemicalImportAppErrorList = res.chemicalAppError
      this.chemicalAppImportCount = res.chemicalAppError.length;

      this.displayedChemicalImportAppErrorList = this.chemicalImportAppErrorList.slice(0, 200);
      this.currentAppIndex = 200;
      this.isChemAppSpinnerLoading = false
      this.showAlertOnlyOnMobile('app')
    }).catch(error => {
      this.$toasted.error('データの取得に失敗しました。')
      this.chemicalImportAppErrorList = [];
      this.displayedChemicalImportAppErrorList = [];
      this.isChemAppSpinnerLoading = false
    })
  }

  private handleAppScroll(event: Event) {
  const target = event.target as HTMLElement;
  const bottomReached = target.scrollTop + target.clientHeight >= target.scrollHeight - 10;

  if (bottomReached && this.currentAppIndex < this.chemicalImportAppErrorList.length) {
    const nextIndex = this.currentAppIndex + 200;
    const nextBatch = this.chemicalImportAppErrorList.slice(this.currentAppIndex, nextIndex);
    this.displayedChemicalImportAppErrorList.push(...nextBatch);
    this.currentAppIndex = nextIndex;
  }
}


  private changeDateFormat(inputDate: string): string {
    if (inputDate == null) return "-";
    const newDateFormat = moment(inputDate).format('YYYY/MM/DD')
    return newDateFormat;
  }

  navigateDateRange(action: string, mode: 'base' | 'app') {
    const isBase = mode === 'base';
    const selectedStartDate = isBase ? this.selectedBaseStartDate : this.selectedAppStartDate;
    const selectedEndDate = isBase ? this.selectedBaseEndDate : this.selectedAppEndDate;
    if (!selectedStartDate || !selectedEndDate) return;
    this.validateDates(mode);
    const isButtonDisabled = isBase ? this.isBaseButtonDisabled : this.isAppButtonDisabled;
    if (isButtonDisabled) {
      if (isBase) this.isBaseButtonDisabled = false;
      else this.isAppButtonDisabled = false;
      return;
    }
    const updateDate = (
      date: moment.MomentInput,
      offset: moment.DurationInputArg1,
      unit: moment.unitOfTime.Base
    ) => moment(date).add(offset, unit).format('YYYY-MM-DD');
    const daysDifference = moment(selectedEndDate).diff(selectedStartDate, 'days') + 1;
    const offset = action === 'previous' ? -daysDifference : daysDifference;
    const newStartDate = updateDate(selectedStartDate, offset, 'days');
    const newEndDate = updateDate(selectedEndDate, offset, 'days');
    if (isBase) {
      this.selectedBaseStartDate = newStartDate;
      this.selectedBaseEndDate = newEndDate;
      this.baseStartDate = newStartDate;
      this.baseEndDate = newEndDate;
      this.handleSearch('base');
    } else {
      this.selectedAppStartDate = newStartDate;
      this.selectedAppEndDate = newEndDate;
      this.appStartDate = newStartDate;
      this.appEndDate = newEndDate;
      this.handleSearch('app');
    }
  }

  validateDates(type: 'base' | 'app'): boolean {
    const isBase = type === 'base';
    const selectedStartDate = isBase ? this.selectedBaseStartDate : this.selectedAppStartDate;
    const selectedEndDate = isBase ? this.selectedBaseEndDate : this.selectedAppEndDate;

    const backupStartDate = isBase ? this.selectedBaseStartDate : this.selectedAppStartDate;
    const backupEndDate = isBase ? this.selectedBaseEndDate : this.selectedAppEndDate;
    const disabledKey = isBase ? 'isBaseButtonDisabled' : 'isAppButtonDisabled';

    if (!selectedStartDate || !selectedEndDate) {
      this[disabledKey] = true;
      return false;
    }

    if (selectedStartDate > selectedEndDate) {
      if (isBase) {
        this.selectedBaseStartDate = backupStartDate;
        this.selectedBaseEndDate = backupEndDate;
      } else {
        this.selectedAppStartDate = backupStartDate;
        this.selectedAppEndDate = backupEndDate;
      }
      this[disabledKey] = true;
      return false;
    } else {
      this[disabledKey] = false;
      if (isBase) {
        this.baseStartDate = selectedStartDate;
        this.baseEndDate = selectedEndDate;
      } else {
        this.appStartDate = selectedStartDate;
        this.appEndDate = selectedEndDate;
      }
      return true;
    }
  }

  private async saveChemicalBaseErrorUpdates() {
    const errmsg: string[] = [];
    this.chemicalImportBasicErrorList.forEach((item: any) => {
      if (item.solution && item.solution.length > 300) {
        errmsg.push(`対応方法は300文字以内で入力してください。(現在は${item.solution.length}文字）`);
      }
    })
    const solutionCheckedWithoutText = this.chemicalImportBasicErrorList.filter((item: any) => {
      return !item.solution?.trim() && item.isBaseSolved;
    });
    if (solutionCheckedWithoutText.length > 0) {
      solutionCheckedWithoutText.forEach((item: any) => {
        errmsg.push(`農薬名称：「${item.chemicalName}」行番号：「${item.rowNum}」の対応方法を入力してください。`);
      });
    }

    const solutionTextWithoutChecked = this.chemicalImportBasicErrorList.filter((item: any) => {
      return item.solution?.trim() && !item.isBaseSolved;
    });
    if (solutionTextWithoutChecked.length > 0) {
      solutionTextWithoutChecked.forEach((item: any) => {
        errmsg.push(`農薬名称：「${item.chemicalName}」行番号：「${item.rowNum}」の対応をチェックしてください。`);
      });
    }


    const modifiedRows = this.chemicalImportBasicErrorList.filter((row: any) => row.isModified);
    if (modifiedRows.length === 0) {
      errmsg.push("農薬基本部一覧に変更されたデータがありません。");
    }

    // エラーメッセージ処理
    if (errmsg.length > 0) {
      alert(errmsg.join('\n'));
      return;
    }
    const payload = {
      chem_base_error_datas: modifiedRows
    };

    if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
        return false
    }

    try {
      await this.$apiClient.doRequest('put', `${this.baseUrl}/update-basic-error`, payload);
      this.$toasted.success("保存しました。");
      this.$store.dispatch('doUpdateIsInputChanged', false);
      this.getChemicalBaseImprotError();
    } catch (error) {
      this.$toasted.error("保存に失敗しました。");
    }
  }

  private async saveChemicalAppErrorUpdates() {
    const errmsg: string[] = [];

    this.chemicalImportAppErrorList.forEach((item: any) => {
      if (item.solution && item.solution.length > 300) {
        errmsg.push(`対応方法は300文字以内で入力してください。(現在は${item.solution.length}文字）`);
      }
    })

    const solutionCheckedWithoutText = this.chemicalImportAppErrorList.filter((item: any) => {
      return !item.solution?.trim() && item.isAppSolved;
    });
    if (solutionCheckedWithoutText.length > 0) {
      solutionCheckedWithoutText.forEach((item: any) => {
        errmsg.push(`農薬名称：「${item.chemicalName}」行番号：「${item.rowNum}」の対応方法を入力してください。`);
      });
    }

    const solutionTextWithoutChecked = this.chemicalImportAppErrorList.filter((item: any) => {
      return item.solution?.trim() && !item.isAppSolved;
    });
    if (solutionTextWithoutChecked.length > 0) {
      solutionTextWithoutChecked.forEach((item: any) => {
        errmsg.push(`農薬名称：「${item.chemicalName}」行番号：「${item.rowNum}」の対応をチェックしてください。`);
      });
    }

    const modifiedRows = this.chemicalImportAppErrorList.filter((row: any) => row.isModified);
    if (modifiedRows.length === 0) {
      errmsg.push("農薬適用部一覧に変更されたデータがありません。");
    }

    // エラーメッセージがある場合の処理
    if (errmsg.length > 0) {
      alert(errmsg.join('\n'));
      return;
    }
    const payload = {
      chem_app_error_datas: modifiedRows
    };

    if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
        return false
    }
    
    try {
      await this.$apiClient.doRequest('put', `${this.baseUrl}/update-app-error`, payload);
      this.$toasted.success("保存しました。");
      this.$store.dispatch('doUpdateIsInputChanged', false);
      this.getChemicalAppImprotError();
    } catch (error) {
      this.$toasted.error("保存に失敗しました。");
    }
  }

  cancelImpErrRecord(type: 'base' | 'app'): boolean {
    if (this.$store.getters.isInputChanged) {
      const result = window.confirm('変更内容を破棄します。よろしいですか。');
      if (!result) return false;
    }
    if (type === 'base') {
      this.getChemicalBaseImprotError();
    } else {
      this.getChemicalAppImprotError();
    }
    this.$store.dispatch('doUpdateIsInputChanged', false);
    return true;
  }


  onResponseCheck(item: any, type: 'base' | 'app') {
    item.isModified = true;
    this.inputChanged();
  }

  async chemTabSwitch(screen: 'base' | 'app') {
    if (this.$store.getters.isInputChanged === true) {
      const proceed = await this.cancelImpErrRecord(screen);
      if (!proceed) return;
    }
    this.chemImpBaseTab = screen === 'base';
    this.chemImpAppTab = screen === 'app';
    this.$store.dispatch('doUpdateIsInputChanged', false);
    if(screen == 'base'){
      this.getChemicalBaseImprotError();
    }
    if(screen == 'app'){
      this.getChemicalAppImprotError();
    }
    this.$nextTick(() => {
    this.initScrollButton();
  });
  }

  chemBaseSort(fieldName: string): void {
    this.chemBaseSortOrder = !this.chemBaseSortOrder;

    this.chemicalImportBasicErrorList.sort((a, b) => {
      const aValue = a[fieldName];
      const bValue = b[fieldName];

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'string' || typeof bValue === 'string') {
        const aStr = (aValue ?? '') as string;
        const bStr = (bValue ?? '') as string;

        if (!aStr && !bStr) return 0;
        if (!aStr) return 1;
        if (!bStr) return -1;

        return this.chemBaseSortOrder
          ? aStr.localeCompare(bStr)
          : bStr.localeCompare(aStr);
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return this.chemBaseSortOrder ? aValue - bValue : bValue - aValue;
      }

      const aDate = new Date(aValue);
      const bDate = new Date(bValue);
      const isDate = !isNaN(aDate.getTime()) && !isNaN(bDate.getTime());
      if (isDate) {
        return this.chemBaseSortOrder
          ? aDate.getTime() - bDate.getTime()
          : bDate.getTime() - aDate.getTime();
      }

      return this.chemBaseSortOrder
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }

  chemAppSort(fieldName: string): void {
    this.chemAppSortOrder = !this.chemAppSortOrder;
    this.chemicalImportAppErrorList.sort((a, b) => {
      const aValue = a[fieldName];
      const bValue = b[fieldName];
      this.displayedChemicalImportAppErrorList = [...this.chemicalImportAppErrorList].slice(0, this.currentAppIndex);

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;

      if (typeof aValue === 'string' || typeof bValue === 'string') {
        const aStr = (aValue ?? '') as string;
        const bStr = (bValue ?? '') as string;

        if (!aStr && !bStr) return 0;
        if (!aStr) return 1;
        if (!bStr) return -1;

        return this.chemAppSortOrder
          ? aStr.localeCompare(bStr)
          : bStr.localeCompare(aStr);
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return this.chemAppSortOrder ? aValue - bValue : bValue - aValue;
      }

      const aDate = new Date(aValue);
      const bDate = new Date(bValue);
      const isDate = !isNaN(aDate.getTime()) && !isNaN(bDate.getTime());
      if (isDate) {
        return this.chemAppSortOrder
          ? aDate.getTime() - bDate.getTime()
          : bDate.getTime() - aDate.getTime();
      }

      return this.chemAppSortOrder
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }

  @Emit('inputChanged')
  private inputChanged() {
    if (store.getters.isInputChanged == false) {
      this.$store.dispatch('doUpdateIsInputChanged', true);
    }
  }


  private getItemsNameByInitial(){
        this.$apiClient.doRequest('get',`${this.baseUrl}/item_name`).then((res) => {
          this.colsNameInital = res.items.sort((a:any,b:any) => a.colName.localeCompare(b.colName));
        })
    }

}